// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoWithLabel_container__3ze4-","label":"InfoWithLabel_label__2R0gP","info":"InfoWithLabel_info__3mF_T"};